import { rankWith, schemaMatches } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { SFGenericSearch } from "@sf-core";
import { baseContainer } from "@base-provider";
import { useTranslation } from "react-i18next";

const getUserAvatar = async (userPrincipalName) => {
  return await baseContainer.activeDirectoryService.getUserAvatar(
    userPrincipalName,
    false
  );
};

const TypeaheadControl = ({ handleChange, path, uischema }) => {
  const { t } = useTranslation();
  return (
    <SFGenericSearch
      label={uischema.i18nKey ? t(uischema.i18nKey) : uischema.label}
      fetchData={(searchTerm) =>
        baseContainer.activeDirectoryService.searchUsers(searchTerm)
      }
      optionRenderer={(option) => {
        return option.displayName ? `${option.displayName} <${option.mail}>` : option.value;
      }}
      onInputChange={(val) => {
        if (!val) {
          handleChange(path, "");
          handleChange("email", "");
          handleChange("userName", "");
          handleChange("imageSrc", "");
        }
      }}
      onSelect={(res) => {
        if (res) {
          getUserAvatar(res.userPrincipalName).then((res) =>
            handleChange("imageSrc", res ?? null)
          );
          handleChange(path, res.displayName);
          handleChange("email", res.mail);
          handleChange("userName", res.userPrincipalName);
        }
      }}
    ></SFGenericSearch>
  );
};

export const TypeaheadControlTester = rankWith(
  101,
  schemaMatches((schema) => schema && schema["customRender"] === "typeahead")
);

export default withJsonFormsControlProps(TypeaheadControl);
